var map = {
	"./404.svg": "sEM+",
	"./antOutline-coffee.svg": "ZQia",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./guide.svg": "z74U",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./password.svg": "QjmH",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./qq.svg": "R2jY",
	"./shoppingCard.svg": "dNDk",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./tianqi.svg": "+mm/",
	"./user.svg": "VdD3",
	"./wechat.svg": "pYJ+",
	"./yujingicon.svg": "dTND",
	"./zip.svg": "0DNV",
	"./上涨.svg": "4Y4U",
	"./业务办理.svg": "ATre",
	"./临时救助.svg": "06pH",
	"./低收入救助.svg": "sH7q",
	"./供养机构管理.svg": "LgiH",
	"./保险.svg": "FMqz",
	"./农村居民.svg": "hvvn",
	"./农村特困.svg": "Zqh9",
	"./办结.svg": "VhHS",
	"./合同.svg": "ZjHM",
	"./在办.svg": "vrpi",
	"./地点.svg": "3YWi",
	"./城市低保1.svg": "WltZ",
	"./城市居民.svg": "o0Fr",
	"./城市特困.svg": "YDV5",
	"./基础信息.svg": "m1Rh",
	"./字典.svg": "ozNv",
	"./字典管理.svg": "lrVY",
	"./家庭档案.svg": "9/Ar",
	"./已办.svg": "jXyS",
	"./待办.svg": "od9J",
	"./成员档案.svg": "Ckwq",
	"./报名.svg": "7gYi",
	"./拨款.svg": "+yg/",
	"./救助发放.svg": "DfMq",
	"./救助标准管理.svg": "FyDh",
	"./文档类型压缩包.svg": "BWjb",
	"./查询统计.svg": "trwq",
	"./用户.svg": "C/fX",
	"./用户管理.svg": "qkzt",
	"./系统管理.svg": "6Sh8",
	"./组织机构.svg": "yOuY",
	"./结算.svg": "YVQX",
	"./缴费.svg": "foqC",
	"./询价.svg": "p86v",
	"./说明.svg": "Mu4j",
	"./账号.svg": "jsBi",
	"./金融.svg": "PtYp",
	"./预算.svg": "TjbH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 75